


export const SETTINGS_OVERRRIDE_NODE_ID = 'override';
export const OVERRIDE_PROPERTY = '\\[.*\\]$';
export const OVERRIDE_PATTERN_WITH_SUBSTITUTION = '\\[(${0})\\]$';
export const OVERRIDE_PROPERTY_PATTERN = new RegExp(OVERRIDE_PROPERTY);

export const Extensions = {
    Configuration: 'base.contributions.configuration',
};

